module.exports = __webpack_public_path__ + "valentinesday_design_cover_pink_design_template_design_facebook_cover_digitalfactory.jpg?9979dda02db1cee64792c1008c34f410";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/valentinesday_design_cover_pink_design_template_design_facebook_cover_digitalfactory.jpg
// module id = 60
// module chunks = 0